<section id="features-details" class="features-details section">

    <div class="container section-title" data-aos="fade-up">
        <h2>Features</h2>
        <p>Discover the convenience of our invoicing platform</p>
    </div>
    <div class="container">

        <div class="row gy-4 justify-content-between features-item">

            <div class="col-lg-6" data-aos="fade-up" data-aos-delay="100">
                <img src="/img/mine/mobile-friendly.svg" class="img-fluid" alt="">
            </div>

            <div class="col-lg-5 d-flex align-items-center" data-aos="fade-up" data-aos-delay="200">
                <div class="content">
                    <h3>Mobile-Friendly Invoicing Made Easy</h3>
                    <p>
                        Our application is designed to be mobile-friendly, ensuring that you can manage your invoices on
                        the go with ease. Whether you're using a smartphone or tablet, our interface adapts seamlessly
                        to your device, providing a smooth and intuitive experience. With just a few taps, you can
                        create, send, and manage your invoices, making invoicing simpler and more convenient than ever
                        before. Say goodbye to the hassle of traditional invoicing and hello to the convenience of
                        mobile-friendly invoicing.
                    </p>
                    <!-- <a href="#" class="btn more-btn">Learn More</a> -->
                </div>
            </div>

        </div><!-- Features Item -->

        <div class="row gy-4 justify-content-between features-item">

            <div class="col-lg-5 d-flex align-items-center order-2 order-lg-1" data-aos="fade-up" data-aos-delay="100">

                <div class="content">
                    <h3>Effortless PDF Downloads for Easy Sharing and Saving</h3>
                    <p>
                        Our application allows you to download your invoices as PDF files with just a click, making it
                        simple to share them with clients or save them for your records. PDFs are universally recognized
                        and can be easily shared via email or other messaging platforms, ensuring that your invoices
                        reach their destination without any hassle. Additionally, PDFs are a secure and reliable format
                        for storing your invoices, giving you peace of mind knowing that your important documents are
                        safely saved and easily accessible whenever you need them.
                    </p>

                    <!-- <a href="#" class="btn more-btn">Learn More</a> -->
                </div>

            </div>

            <div class="col-lg-6 order-1 order-lg-2" data-aos="fade-up" data-aos-delay="200">
                <img src="/img/mine/Sync-pana.svg" class="img-fluid" alt="">
            </div>

        </div><!-- Features Item -->
    </div>
</section>